import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, SelectUI, AutoCompleteSelectUI } from '../Interface';
import { DocumentDirectionField, DocumentDirection } from '../../config/DocumentDirection';
import { BpTypeList } from '../../config/company';
import { AreaTypeList } from '../../config/companyGroup';
import { SubjectOption } from '../../config/vatCodes';

export const VatDeterminationFields = ({ viewField, autoCompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  const dDirectionOptions = DocumentDirectionField.filter((option) => option.value !== DocumentDirection.INTERNAL);

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5 items-center">
      <div className="col-span-4 md:col-span-1">
        <Field
          name="documentDirection"
          component={SelectUI}
          fullWidth
          option={dDirectionOptions}
          value={values.documentDirection ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('documentDirection', value ?? null).then(() => {
              validateField('documentDirection');
            });

            setFieldValue('vatCode', null).then(() => {
              validateField('vatCode');
            });
          }}
          label={<FormLabelUI text="Irány" />}
          helperText={<FormErrorUI message={errors.documentDirection} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.documentDirection !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="bpType"
          component={SelectUI}
          fullWidth
          option={BpTypeList}
          value={values.bpType ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('bpType', value ?? null).then(() => {
              validateField('bpType');
            });
          }}
          label={<FormLabelUI text="ÜP típus" />}
          helperText={<FormErrorUI message={errors.bpType} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.bpType !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="area"
          component={SelectUI}
          fullWidth
          option={AreaTypeList}
          value={values.area ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('area', value ?? null).then(() => {
              validateField('area');
            });
          }}
          label={<FormLabelUI text="Teljesítés országa" />}
          helperText={<FormErrorUI message={errors.area} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.area !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="vatCodeSubject"
          component={SelectUI}
          fullWidth
          option={SubjectOption}
          value={values.vatCodeSubject ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('vatCodeSubject', value ?? null).then(() => {
              validateField('vatCodeSubject');
            });
          }}
          label={<FormLabelUI text="Tárgya" />}
          helperText={<FormErrorUI message={errors.vatCodeSubject} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.vatCodeSubject !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="vatCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Áfakulcs" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.vatCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('vatCode', newVal?.value ?? null).then(() => {
              validateField('vatCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.vatCode !== '' }}
          selectedValue={values.vatCode}
          selectedLabelValue={autoCompleteOptions?.vatCode.find((item) => item.value === values.vatCode)?.label || ''}
          dataset={
            values.documentDirection === DocumentDirection.INCOMING
              ? autoCompleteOptions.purchaseVatCode
              : autoCompleteOptions.salesVatCode
          }
          isOptionEqualToValue={(option, value) => option.value === value}
        />
      </div>
    </div>
  );
};
